module.exports = { //例子 this.$i18n.t('main.submit_audit')  {{$t('main.status_name')}}

    main: {
        'text1': 'View Profile',
        'text2': 'Change Password',
        'text3': 'Submit Document',
        'text4': 'Logout',
        'text5': 'Logout confirmation',
        'text6': 'Are you sure you want to logout from the dashboard?',
        'text7': 'Cancel',
        'text8': 'Logout',
        'text9': 'Thank you!',
        'text10': 'We have received your request for assistance to complete your profile. Our relationship manager will be in contact within 3 working days.',
        'text11': 'Ok',
        'text12': 'Dashboard',
        'text13': 'My Transaction',
        'text14': 'Deposit',
        'text15': 'Transfer & Payments',
        'text16': 'Fiat Deposit',
        'text17': 'FIat Withdrawal',
        'text18': 'OTC',
        'text19': 'FX',
        'text20': 'KYC',
        'text21': 'Corporate Declaration',
        'text22': 'Company Information',
        'text23': 'Ownership/Controller/ Shareholder Information',
        'text24': 'Trading Authorization Form',
        'text25': 'BLOCKCHAIN',
        'text26': 'FIAT',
        'text27': 'PRODUCT',
        'text28': 'COMING SOON',
        'text29': 'This feature is coming soon!',
        'text30': "Don't have an account yet?",
        'text31': 'Sign Up',
        'text32': 'We’ll email you a reset link shortly.',
        'text33': 'Forgot Your Password?',
        'text34': 'Please enter the email you used for registration.',
        'text35': 'Email Address',
        'text36': 'Submit',
        'text37': 'Already have an account?',
        'text38': 'Login',
        'text39': 'Please input your email',
        'text40': 'USDT Balance',
        'text41': 'USDC Balance',
        'text42': 'USD Balance',
        'text43': 'SGD Balance',
        'text44': 'ETH Balance',
        'text44_1': 'ETH',
        'text45': 'BTC Balance',
        'text46': 'Welcome On Board!',
        'text47': 'Welcome! Thank you for choosing Finext Eastern Bank! You now have access to the Dashboard. To fully enable the rest of our banking services,  please submit the relevant documents by clicking on the link below.',
        'text48': 'Engage A Relationship Manager',
        'text49': 'Should you require any assistance on the submission of your documents, please click the button below and we will contact you within 3 working days.',
        'text50': 'Finish the setup on my own/skip(?)',
        'text51': 'Document Submission',
        'text52': 'I have some  or all of the documents required, and I would like to proceed with the submission. (Note that you will be able to save your submitted documents progressively).',
        'text53': 'Proceed',
        'text54': 'List Of Documents Required',
        'text55': 'Company’s certificate of incorporation/ACRA',
        'text56': 'All directors’ identification',
        'text57': 'Ownership/control structure',
        'text58': "All shareholders’ and controller’s identification",
        'text58_y': "(ID or Passport, Duly Certified by Notary Public, Company Secretary or Certified Public Accountant with Membership Number)",
        'text59': 'Authorized personnels’ identification',
        'text60': 'Memorandum & articles of association',
        'text61': 'Company’s proof of address',
        'text61_y': '(Utility bill or bank statement issued within 3 months from the date of this submission)',
        'text62': 'Any relevant licenses',
        'text63': 'Parent company documents (if applicable)',
        'text64': 'Show less',
        'text65': 'I’ll do it later',
        'text66': 'Please complete all the sections before submission',
        'text67': 'Submit Now',
        'text68': 'Completed',
        'text69': 'Not Completed',
        'text69_y': 'Corporate Declaration',
        'text70': "This section requires submission of identification documents of the company's directors and shareholders",
        'text71': 'Edit',
        'text72': 'Please make sure you have completed all the sections before submitting',
        'text73': 'Corporate Declaration information is incomplete',
        'text74': 'Company information is incomplete',
        'text75': 'Ownership/controller/shareholder information is incomplete',
        'text76': 'Trading authorization form information is incomplete',
        'text77': 'We have received your submission',
        'text78': 'Thank you for your submission! We will review it and get back to you shortly.',
        'text79': 'Saved',
        'text80': 'Do you want to submit the KYC now?',
        'text81': 'You have completed all the sections!',
        'text82': 'Please ensure you have filled up all the fields below.',
        'text83': 'Full Name',
        'text84': 'ID/Passport Number',
        'text85': 'Job Title',
        'text86': 'Contact Number',
        'text87': 'ID/Passport',
        'text87_y': 'Front and Back of Identity Card (If Singaporean)/ Passport (If Foreigner)',
        'text88': 'Drag and drop files here',
        'text89': 'Choose File',
        'text90': '*Maximum 10 files',
        'text91': 'Add another member',
        'text92': '*Up to 3 members',
        'text93': 'Declaration',
        'text94': 'By submit below, the client confirms that the purpose for using BETH Corporation’s services is legitimate, that funds concerned, handled or dealt with, are not proceeds from any tax crime under the laws of Dominica or any other jurisdiction.',
        'text95': 'The client agrees that it will bear sole responsibility for the accuracy and completeness of the information provided to BETH Corporation, except for any information created solely by the client. The client represents and warrants that the information will be accurate and complete in all material respects and not misleading and will not omit to state any fact or information which would be material in its estimation.',
        'text96': 'Director’s Acknowledgment',
        'text97': 'Name Of Director',
        'text98': 'Designation Of Director',
        'text99': 'Date',
        'text100': 'Show the description of this label',
        'text101': 'dd/mm/yyyy',
        'text102': 'Signature Of Director',
        'text103': 'Use your mouse or trackpad to sign within the box',
        'text104': 'Save',
        'text105': 'Signature',
        'text106': 'Add up to 3',
        'text107': 'Data cannot be empty',
        'text108': 'Saved successfully',
        'text109': 'Please sign before submitting',
        'text110': 'Please ensure you have selected the correct input.',
        'text111': 'Are you a financial institution?',
        'text112': 'Yes',
        'text113': 'No',
        'text114': 'BETH corporation’s AML/CFT questionnaire',
        'text115': 'Latest signed AML/CFT policy',
        'text116': 'Latest signed enterprise-wide risk assessment',
        'text117': 'Memorandum & articles of association',
        'text118': "Company's Certificate of Incorporation (COI):",
        'text118_y': "1. ACRA if registered in Singapore;",
        'text118_y2': "2. If company is registered overseas, please provide an English translated COI which has been certified true copy within 3 months from submission",
        'text119': '(If registered in Singapore) - Dated within 3 months or overseas quivalent in english',
        'text120': 'All directors’ identification',
        'text121': '(ID or passport, duly certified by notary public, company secretary or certified public accountant with membership number)',
        'text122': 'All ultimate beneficial owners’ identification',
        'text123': 'Parent company documents (if applicable)',
        'text124': '(Utility bill or bank statement issued within 3 months from the date of this submission)',
        'text125': '(If registered in Singapore) - Dated within 3 months or overseas equivalent in english',
        'text126': 'Purpose Of Transaction',
        'text127': '(Document such as payment invoice etc.)',
        'text128': 'Please confirm corporate declaration in order to proceed.',
        'text129': 'IMPORTANT: All the documents uploaded in this section so far WILL NOT BE SAVED.',
        'text130': 'Confirm',
        'text131': 'Name Of Shareholder',
        'text132': 'Ownership Percentage',
        'text133': 'Passport Number',
        'text134': 'Issuing Country',
        'text135': '- Please Select -',
        'text136': 'Add another shareholder',
        'text137': '*Up to 5 members',
        'text138': 'Main Officers And Directors Information',
        'text139': 'Position',
        'text140': 'Add another officer',
        'text141': 'Add up to 5',
        'text142': 'Company Name',
        'text143': 'Registered Address',
        'text144': 'Country',
        'text145': 'Mailing Address',
        'text146': 'Telephone Number',
        'text147': 'Company Website',
        'text148': 'Registration Number',
        'text149': 'Country Of Registration',
        'text150': 'Date Of Registration',
        'text151': 'Nature Of Business',
        'text152': 'Entity Type',
        'text153': 'Sole Proprietorship',
        'text154': 'Limited Partnership',
        'text155': 'Limited Liability Company',
        'text156': 'Corporation',
        'text157': 'Others',
        'text158': 'Countries Where Business Are Conducted',
        'text159': 'No. Of Employees',
        'text160': 'Approximate No. Of Clients',
        'text161': 'Top 5 Countries Where Your Clients Are Based',
        'text162': 'Annual Turnover (USD)',
        'text163': '(You may be required to provide additional documentation)',
        'text164': 'Source Of Wealth',
        'text165': 'Top 3 Most Frequent Transacted Currencies',
        'text166': 'Monthly Expected Transaction Volume',
        'text167': '<$10,000 USD',
        'text168': '$10,000 - $100,000 USD',
        'text169': '$100,000 - $500,000 USD',
        'text170': '$500,000 - $1,000,000 USD',
        'text171': '$1,000,000 - $10,000,000 USD',
        'text172': '>$10,000,000 USD',
        'text173': 'Monthly Expected Transaction Frequency',
        'text174': 'AD HOC TRANSACTION REQUIREMENT',
        'text175': 'LESS THAN 10 TRANSACTIONS',
        'text176': 'BETWEEN 10 TO 20 TRANSACTIONS',
        'text177': 'MORE THAN 20 TRANSACTIONS',
        'text178': 'No. Of Years In Operation',
        'text179': 'Welcome Back!',
        'text180': 'We make banking in the new asia economy simple, fast and reliable.',
        'text181': 'Don’t have an account yet?',
        'text182': 'Thank you for signing up! Your account has been successfully created. Please Login to complete your profile.',
        'text183': 'Password has been successfully updated. Please login with your new password.',
        'text184': 'Welcome to',
        'text185': 'Email',
        'text186': 'Password',
        'text187': 'Forgot Password?',
        'text188': 'Forget password',
        'text189': 'Sure',
        'text190': 'Captcha',
        'text191': 'E-mail can not be empty',
        'text192': 'Password can not be blank',
        'text193': 'Verification code must be filled',
        'text194': 'Incorrect verification code',
        'text195': 'Login successful',
        'text196': 'Create An Account',
        'text197': 'Email OTP',
        'text198': 'Request OTP',
        'text199': 'Mobile Number',
        'text200': 'Country Code',
        'text201': 'Confirm Password',
        'text202': 'CI Code (Optional)',
        'text203': 'Please enter Full Name',
        'text204': 'Please enter your email',
        'text205': 'Please fill in the email verification code',
        'text206': 'Please fill in your phone number',
        'text207': 'Please fill in the password',
        'text208': 'Please fill in the confirm password',
        'text209': 'The two passwords do not match, please re-enter',
        'text210': 'Registration success',
        'text211': 'Reset your password',
        'text212': 'Please enter your new password.',
        'text213': 'New Password',
        'text214': 'Confirm New Password',
        'text215': 'Successfully modified',
        'text216': 'Please Submit The Required Documents In Order To Access The Dashboard',
        'text217': 'Company’s certificate of incorporation/ACRA',
        'text218': 'Shareholder',
        'text219': 'Front and Back of Identity Card (If Singaporean)/ Passport (If Foreigner)',
        'text220': 'Full name',
        'text221': 'Add up to 3 shareholders',
        'text222': 'Please fill in name',
        'text223': 'Must upload a company profile',
        'text224': 'The information of a shareholder must be added',
        'text225': 'Uploaded successfully',
        'text226': 'Update your password at anytime.',
        'text227': 'Complete your profile to get access to all the features.',
        'text228': 'We will review it and get back to you shortly.',
        'text229': 'Pending review',
        'text230': 'Submission failed. We will contact you shortly.',
        'text231': 'Submission has failed. Our relationship manager will contact you shortly.',
        'text232': 'Complete Now',
        'text233': 'Do you require any assistance? Click here to request for a relationship manager to assist you.',
        'text234': 'Edit Profile',
        'text235': '*File size maximum 5MB',
        'text236': 'Update',
        'text237': 'Current Password',
        'text238': 'Please fill in a new password',
        'text239': 'File size cannot exceed 5M',
        'text240': 'Wrong file type',
        'text241': 'Corporate Profile',
        'text242': '- Please select a date -',
        'text243': 'Download here',
        'text244': 'An OTP has been sent to your email above, please enter the code',
        'text245': 'Password must be at least 8 characters and contain at least uppercase, lowercase, and 1 number',
        'text246': 'The password can only be a combination of 8 to 12 characters of uppercase letters + lowercase letters + numbers',
        'text247': 'Parent company documents (if applicable)',
        'text248': 'Due to inactivity, you have been logged out for security purposes. Please login again.',
        'text249': 'Show all',
        'text250': 'Email Address',
        'text251': 'Account Summary',
        'text252': 'Account Name',
        'text253': 'Account Number',
        'text254': 'Reference',
        'text255': 'Balance',
        'text256': "This section requires the upload of company supported documents such as the director's and shareholder's identification, etc.",
        'text257': 'Session expired soon',
        'text258': 'Do you wish to continue your session?',
        'text259': 'Logout now',
        'text260': 'Stay login',
        'text261': '*Maximum 10 files, jpeg, pdf, png with max size of 10MB',
        'text262': 'You are navigating away from this page. All documents uploaded will not be saved',
        'text263': 'Save and Proceed',
        'text264': 'Access denied',
        'text265': "This feature is only accessible once your KYC has been approved. You may check on your KYC status on the profile page. We're sorry for any inconvenience caused.",
        'text266': 'OK',
        'text267': 'Private Banking Products',
        'text268': 'Structured Products',
        'text269': 'Investment Banking',
        'text270': 'Transaction History',
        'text271': 'New Fiat Deposit',
        'text272': 'Click on View My Bank Details button to see bank details. Please note that minimum deposit of 1,000 USD or equivalent is required. ',
        'text273': 'Our Bank Details',
        'text274': 'Please ensure that you include the reference ',
        'text275': ' when providing your name or initials to your bank for transfer to BETH account. The reference is an unique identifier that enables us to identify the incoming transfers to your BETH account. ',
        'text276': 'Name of Bank',
        'text277': 'Beneficiary Bank Address',
        'text278': 'Bank Code',
        'text279': 'Branch Name',
        'text280': 'Beneficiary Bank Account Number',
        'text281': 'Bank Account Name',
        'text282': 'Currency Type',
        'text283': 'SWIFT Address/Code',
        'text284': 'Company Address',
        'text285': 'Copy bank details',
        'text286': 'New Digital Asset Deposit',
        'text287': 'Copy or scan the following QR codes to select your deposit address for your Digital Asset wallet.',
        'text288': 'USDT Balance (ERC20, BEP20)',
        'text288_1': 'USDT Balance',
        'text288_3': 'USDT',
        'text288_2': '(ERC20, BEP20)',
        'text289': 'USD Approximate',
        'text290': 'Address',
        'text291': 'Copy',
        'text292': 'USDC Balance (ERC20, BEP20)',
        'text292_1': 'USDC Balance',
        'text292_3': 'USDC',
        'text292_2': '(ERC20, BEP20)',
        'text293': 'BTC Balance',
        'text293_1': 'BTC',
        'text294': 'ETH Balance',
        'text295': 'USDT (TRC20) Balance',
        'text296': 'USDC (TRC20) Balance',
        'text297': 'Copy Successfully',
        'text298': 'Name of Bank : ',
        'text299': 'Bank Address : ',
        'text300': 'Bank Code : ',
        'text301': 'Branch Name : ',
        'text302': 'Bank Account Number : ',
        'text303': 'Bank Account Name : ',
        'text304': 'Country : ',
        'text305': 'Currency : ',
        'text306': 'SWIFT Address/Code : ',
        'text307': 'Company Address : ',
        'text308': 'Reference : ',
        'text309': 'Transaction Details',
        'text310': 'Transaction Date',
        'text311': 'Transaction Hash',
        'text312': 'Transaction ID',
        'text313': 'Details',
        'text314': 'Amount',
        'text315': 'Sender Address',
        'text316': 'Status',
        'text317': 'Success',
        'text318': 'Pending Approval',
        'text319': 'Rejected',
        'text320': 'Transaction In Process',
        'text321': 'Transaction Failed',
        'text322': 'Filter',
        'text323': 'Date Range',
        'text324': 'Start Date',
        'text325': 'End Date',
        'text326': 'TXID',
        'text327': 'Transaction Type',
        'text328': 'All',
        'text329': 'Reset',
        'text330': 'Search',
        'text331': '',
        'text332': 'White listings indicate Digital Asset Transactions',
        'text333': 'Export',
        'text334': 'Currency Type',
        'text335': 'There is currently no data to download.',
        'text336': 'Fiat Transaction History',
        'text337': 'Digital Asset Transaction History',
        'text338': 'Transfer & Payments Details',
        'text339': 'Withdrawal Amount',
        'text340': 'Recipients Details',
        'text341': 'Name',
        'text342': 'Wallet Address',
        'text343': 'Network Type',
        'text344': 'All',
        'text346': 'Transaction History',
        'text347': 'Transfer Amount',
        'text348': 'Beneficiary Name',
        'text349': 'Transfer & Payment Details',
        'text350': 'Recipient Gets',
        'text351': 'Bank Details',
        'text352': 'Beneficiary Bank Name',
        'text353': 'Beneficiary Bank Swift Code',
        'text354': 'Intermediary Bank Details (Optional)',
        'text355': 'Intermediary Bank Name',
        'text356': 'Intermediary Bank Country',
        'text357': 'Intermediary Bank Swift Code',
        'text358': 'Intermediary Bank Address',
        'text359': 'Other details',
        'text360': 'Purpose of Transaction',
        'text361': 'Add New Address',
        'text362': 'My Addresses',
        'text363': 'Delete',
        'text364': 'No Data',
        'text365': 'Recipient Details',
        'text366': 'Wallet Address',
        'text367': 'Remove Confirmation',
        'text368': 'Are you sure you want to remove this address from your list?',
        'text369': 'Remove',
        'text370': 'Manage My Addresses',
        'text371': 'Please fill in name',
        'text372': 'Please fill in the address',
        'text373': 'Please choose the type',
        'text374': 'Added successfully',
        'text375': 'Edited successfully',
        'text376': 'Successfully deleted',
        'text377': 'Add New Payee',
        'text378': 'My Payee',
        'text379': 'Are you sure you want to remove this payee from your list?',
        'text380': 'Payee',
        'text381': 'Please fill in the bank account number',
        'text382': 'Please fill in the name of the beneficiary',
        'text383': 'Please fill in the bank code',
        'text384': 'Please fill in the bank address',
        'text385': 'Please fill in the name of the intermediary bank',
        'text386': 'Please select the country of the intermediary bank',
        'text387': 'Please fill in the intermediary bank code',
        'text388': 'Please fill in the intermediary bank address',
        'text389': 'Enter Amount',
        'text390': 'Review Details',
        'text391': 'Select Recipient',
        'text392': 'Add New Wallet Address',
        'text393': 'Save as Favourite Recipient',
        'text394': 'Continue',
        'text395': 'Save',
        'text396': 'New Transfer & Payment (Digital Asset)',
        'text397': 'Please ensure that all the details below are correct before submission.',
        'text398': 'Transfer & Payment Details',
        'text399': 'Enter OTP',
        'text400': 'Confirm & Proceed',
        'text401': 'We’re received your request!',
        'text402': 'Your withdrawal request will be processed within 3 working days.',
        'text403': 'Please fill in the verification code',
        'text404': 'Favourite Recipient',
        'text405': 'Other Details',
        'text406': 'Email Address (Optional)',
        'text407': 'Business Expenses',
        'text408': 'Collection Payment',
        'text409': 'Cash Disbursement',
        'text410': 'Purchase Sale Of Goods',
        'text411': 'Installment Hire Purchase Agreement',
        'text412': 'Intra Company Payment',
        'text413': 'Invoice Payment',
        'text414': 'Supplier Payment',
        'text415': 'Trade Services',
        'text416': 'Treasury Payment',
        'text417': 'Charity Payment',
        'text418': 'Education',
        'text419': 'Study',
        'text420': 'Foreign Worker Levy',
        'text421': 'Government Insurance',
        'text422': 'Insurance Premium',
        'text423': 'Investment & Securities',
        'text424': 'Loan',
        'text425': 'Dividend',
        'text426': 'Interest',
        'text427': 'Other',
        'text428': 'Rebate',
        'text429': 'Refund',
        'text430': 'Withholding (?)',
        'text431': 'Cable TV Bill',
        'text432': 'Credit Card Payment',
        'text433': 'Carpark Charges',
        'text434': 'Debit Card Payment',
        'text435': 'Dental Services',
        'text436': 'Payment of Fees & Charges',
        'text437': 'Hospital Care',
        'text438': 'Medical Services',
        'text439': 'Telephone Bill',
        'text440': 'Rent',
        'text441': 'Town Council Service Charges',
        'text442': 'Road Pricing',
        'text443': 'Utilities',
        'text444': 'Bonus Payment',
        'text445': 'Commission',
        'text446': 'Salary Payment',
        'text447': 'Goods & Services Tax',
        'text448': 'Net Income Tax',
        'text449': 'Property Tax',
        'text450': 'Road Tax',
        'text451': 'Tax Payment',
        'text452': 'New Transfer & Payment (Fiat)',
        'text453': 'Please fill in the correct email',
        'text454': 'Please select the purpose of the transaction',
        'text455': 'Transfer/Payment to Other Account',
        'text456': 'It may take up to 3 working days for the funds to reach the intended recipient',
        'text457': 'Transfer to Other Currency',
        'text458': 'You Send',
        'text459': 'Available Balance in ',
        'text460': 'Recipient Gets',
        'text461': 'The rate will be refreshed and amount updated every 5 minutes',
        'text462': 'Transfer/Payment to Other Address',
        'text463': 'Please ensure that you have entered the correct details before submission.',
        'text464': 'Transfer/Payment Amount',
        'text465': 'Refresh the Page',
        'text466': 'The rate will be refreshed and amount updated every 5 minutes. Please click OK if you wish to continue your transaction/payment.',
        'text467': 'Refresh',
        'text468': 'Withdrawal is unavailable as withdrawal amount is currently 0',
        'text469': 'Please enter the withdrawal amount',
        'text470': 'The amount of coins to be withdrawn is currently less than the minimum amount. The minimum amount of coins to be withdrawn is:',
        'text471': 'Withdrawal exceeds your maximum amount',
        'text472': 'The Deposit Reference is a unique identifier that enables us to identify the incoming transfers to your BETH account. Please ensure that you include the reference ',
        'text473': ' when providing your name or initials to your bank for transfer to BETH account.',
        'text474': 'Deposit Reference',
        'text475': 'CNY Balance',
        'text476': 'GBP Balance',
        'text477': 'AUD Balance',
        'text478': 'HKD Balance',
        'text479': 'Transaction',
        'text480': 'Deposit',
        'text481': 'Transfer & Payments',
        'text482': 'Transfer to Fiat',
        'text483': 'Please select a currency',
        'text484': '(TRC20)',
        'text485': 'We are sorry, you do not have access to this function yet.',
        'text486': 'This function will be available to you once your profile has been approved',
        'text487': 'You may check profile status on the profile page.',
        'text488': 'Please ensure that the wallet address matches the network type as entered below. Entering any other wallet addresses from another network may result in the loss of your funds',
        'text489': 'Refusal Reason',
        'text490': '*Maximum 1 files(JPEG or PNG)',
        'text491': 'BETH Debit Card',
        'text492': 'Directors and associates are eligible to apply for this card',
        'text493': 'Apply Now',
        'text494': 'Beth Debit Card',
        'text495': 'Coming Soon',
        'text496': 'Something exciting is coming soon! Please stay tuned.',
        'text497': "Please indicate who you're applying for",
        'text498': 'Director',
        'text499': 'Associate',
        'text500': 'Please select shareholders',
        'text501': 'VISA Debit Card Fees & Charges',
        'text502': 'Secured Visa (USD)',
        'text503': 'Annual Membership Fee',
        'text504': 'Card Cost',
        'text505': 'Inactivity Fee',
        'text506': 'Card Activation',
        'text507': 'POS/Online Purchase',
        'text508': 'ATM Withdrawal',
        'text509': 'ATM Balance Inquiry',
        'text510': 'Load Fee (Direct to Card)',
        'text511': 'Apply Card',
        'text512': 'Cards',
        'text513': 'Please ensure all the details below is correct before submitting the application.',
        'text514': 'Card details',
        'text515': 'Card Type',
        'text516': 'VISA Debit Card',
        'text517': 'Application Details',
        'text518': 'Title',
        'text519': 'First Name',
        'text520': 'Last Name',
        'text521': 'Username (For Internet banking login)',
        'text522': 'Date of Birth',
        'text523': 'Name to Appear on Card',
        'text524': 'Country of Residence',
        'text525': 'State',
        'text526': 'City',
        'text527': 'Postal Code',
        'text528': 'KYC Details',
        'text529': 'National Identity/Passport Number',
        'text530': 'Issued Date',
        'text531': 'Expiration Date',
        'text532': 'Front of National Identify Card or Passport',
        'text533': 'Back of National Identify Card or Passport',
        'text534': 'Proof of Address',
        'text535': 'Proof of Address Issued By',
        'text536': 'Proof of Address Issued Date',
        'text537': 'Thank you for your submission.',
        'text538': 'We will review the application and update you via email',
        'text539': 'Please complete the application details below',
        'text540': 'Mr',
        'text541': 'Ms',
        'text542': 'Mrs',
        'text543': '(Please submit Utility Bill, Bank Statement, Bank Letter, or Credit Card Statement, dated within 3 months from date of application.)',
        'text544': '(Issuing authority name, such as the name of the utility company or bank.)',
        'text545': '(The date stamp on the document when it was issued. May not be more than 90 days old.)',
        'text546': 'Please Select Title',
        'text547': 'Please Fill In First Name',
        'text548': 'Please Fill In Last Name',
        'text549': 'Please Fill In Username',
        'text550': 'Please Fill In Email',
        'text551': 'Please Fill In Mobile Number',
        'text552': 'Please Select Date of Birth',
        'text553': 'Please Fill In Name to Appear on Card',
        'text554': 'Please Fill In Address',
        'text555': 'Please Select Country of Residence',
        'text556': 'Please Fill In State',
        'text557': 'Please Fill In City',
        'text558': 'Please Fill In Postal Code',
        'text559': 'Please Fill In National Identity/Passport Number',
        'text560': 'Please Select Issued Date',
        'text561': 'Please Select Expiration Date',
        'text562': 'Please Upload Front of National Identify Card or Passport',
        'text563': 'Please Upload Back of National Identify Card or Passport',
        'text564': 'Please Upload Proof of Address',
        'text565': 'Please Fill In Proof of Address Issued By',
        'text566': 'Please Select Proof of Address Issued Date',
        'text567': 'Card Holder Name',
        'text568': 'Card Balance',
        'text569': 'UnionPay Debit Card',
        'text570': 'Verification in progress',
        'text571': 'Verification Approved',
        'text572': 'Verification Failed',
        'text573': 'KYC Issuing Country',
        'text574': 'Please select country code',
        'text575': 'Please select KYC Issuing Country',
        'text576': 'Proof of Address Type',
        'text577': 'Language of the submitted document',
        'text578': 'Please select ID/Passport language',
        'text579': 'Company Name',
        'text580': 'Top-up History',
        'text581': 'Application Status',
        'text582': 'Card Number（Showing Last 4 Digits）',
        'text583': 'Approve',
        'text584': 'Reject',
        'text585': 'Approved',
        'text586': 'Pending',
        'text587': 'processing',
        'text588': 'Active',
        'text589': 'Blocked',
        'text590': 'You have approved the card application.',
        'text591': 'Thank you for approving the card, we will review your application within 3 working days.',
        'text592': 'Company Application Status',
        'text593': 'Card Balance',
        'text594': 'Reject card',
        'text595': 'Are you sure you want to reject this card application?',
        'text596': 'Tell us why',
        'text597': 'Confirm to Reject',
        'text598': 'Please indicate reasons',
        'text599': 'Please ensure your KYC approved',
        'text600': 'Copy Link',
        'text601': 'Credit Card Statement',
        'text602': 'Utility Bill',
        'text603': 'Bank Statement',
        'text604': 'Bank Letter',
        'text605': 'English',
        'text606': 'Spanish',
        'text607': 'French',
        'text608': 'Arabic',
        'text609': 'Chinese',
        'text610': 'Japanese',
        'text611': 'Russian',
        'text612': 'Portuguese',
        'text613': 'German',
        'text614': 'Italian',
        'text615': 'Hindi',
        'text616': 'Other',
        'text617': 'Issuing Country',
        'text618': 'Proof of Address (Front Page)',
        'text619': 'Proof of Address (Back, optional)',
        'text620': 'Notes (Optional)',
        'text621': 'Please select Proof of Address language',
        'text622': 'Search',
        'text623': 'e.g. Card holder name or last 4-digits of the card number',
        'text624': 'All Status',
        'text625': 'Activate',
        'text626': 'Top-up',
        'text627': 'Activate card',
        'text628': 'By activate the card, please enter the following details for the verification:',
        'text629': 'Card Number 16-Digits',
        'text630': 'Kit Code',
        'text631': 'Activate Successfully!',
        'text632': 'Your card has been successfully activated',
        'text633': 'Processing Fee & Top-up Charges',
        'text634': 'Annual Fee',
        'text635': 'Minumum Top-up Amount',
        'text636': 'Maximum Top-up Amount',
        'text637': 'Top-up your card',
        'text638': 'Please ensure you have sufficient balance in your account wallet.',
        'text639': 'Top-up was successful',
        'text640': 'Top-up amount of USD',
        'text640_r': ' was successful',
        'text641': 'Top-up Failed',
        'text642': 'Something went wrong. Please try again later.',
        'text643': 'Retry',
        'text644': 'Card Activation Fee',
        'text645': 'Processing Fee',
        'text646': 'Date & Time',
        'text647': 'From',
        'text648': 'Top-up Amount (USD)',
        'text649': 'Failed',
        'text650': 'Min is ',
        'text651': ' & max is ',
        'text652': 'Available Balance in ',
        'text653': 'The top-up amount has exceed your daily top-up limit which is ',
        'text654': ' Please reduce the top-up amount to continue.',
        'text655': 'You do not have sufficient ',
        'text655_2': ' balance in your bank account. Please top-up your bank account or choose another currency.',
        'text656': 'Top-up My Account Now',
        'text657': 'You’ll Get',
        'text658': 'Card Number',
        'text659': 'Card limit',
        'text660': 'Please key in 16 digit card number',
        'text661': 'Please key in Identification Number',
        'text662': 'Amount is too little',
        'text663': 'Amount is lesser than the minimum ',
        'text664': 'Amount has exceeded limit',
        'text665': 'Type',
        'text666': 'Top Up',
        'text667': 'Card Cost',
        'text668': 'Card Activation Fee',
        'text669': 'Processing Fee',
        'text670': 'Card Replacement',
        'text671': 'All above chargen are in USD',
        'text672': 'Username format is uppercase and lowercase English letters, numbers, underscores',

        // BETH
        'text673_ok': 'Card Balance has been Updated',
        'text673': 'Pair Authenticator App with your account',
        'text674': 'Scan the QR code',
        'text675': 'Scan or enter the setup key above in your Authenticator App, then input the generated 6-Digit Code to proceed.',
        'text676': 'Please input the 6-Digit Code from your Authenticator App to login.',
        'text677': '6-Digit Code',
        'text678': 'Please enter your verified email. We will send an instruction to your email.',
        'text679': '(Minimum 8 characters containing at least an uppercase, a lowercase, a number and a special character)',
        'text680': 'Password Updated',
        'text681': 'You have successfully updated your password. Please login with the new password.',
        'text682': 'Login Now',
        'text683': 'Gender',
        'text684': 'Please enter the 6-Digit Code from your Authenticator App.',
        'text685': 'Successful Card Activation',
        'text686': 'Your Debit Card ending ',
        'text686_r': ' is now activated.',
        'text687': 'Manage Cards',
        'text688': 'My Card(s)',
        'text689': 'Profile',
        'text690': 'VALID THRU',
        'text691': 'CVV',
        'text692': 'Activate This Card',
        'text693': 'Setup 2 Factor Authentication',
        'text694': 'Basic Details',
        'text695': 'Edit Address',
        'text696': 'New Address',
        'text697': 'We will review your document within 3 working days. Please check your profile for the update.',
        'bt1': 'Powered by Finext Eastern Bank',
        'bt2': 'Apply New Card',
        'bt3': '* Your wallet can only receive our designated type of tokens. If you have accidentally credited the wrong token, please contact support@bethfinance.com for assistance.',
        'bt4': '',
        'bt5': '',
        'bt6': '',
        'bt7': '',
        'bt8': '',
        'bt9': '',
        'bt10': '',

        'btext674': 'Make a deposit from a range of fiat currencies.',
        'btext675': 'Make a Fiat Deposit',
        'btext676': 'Deposit Details',
        'btext677': 'We have received your request! ',
        'btext678': 'Your relationship manager/account manager has been notified and will contact you shortly.',
        'btext679': 'Other Currency',
        'btext680': 'From Bank',
        'btext681': 'Which country are you depositing from?',
        'btext682': 'Currency',
        'btext683': 'Please select a Currency',
        'btext684': 'Please fill in the Amount',
        'btext685': 'Please fill in from Bank',
        'btext686': 'Please select from Countries',
        'btext687': 'New Fiat Deposit to ',
        'btext688': 'Transfer & Payment',
        'btext689': 'Load Card',
        'btext690': 'Card Annual Fee',
        'btext691': 'Card Cost Fee',
        'btext692': 'Card Activation Fee',
        'btext693': 'Refund Annual Fee',
        'btext694': 'Refund Card Cost Fee',
        'btext695': 'Conversion Fee (USDT to USD)',
        'btext696': 'Conversion Fee (USDC to USD)',

        'text698': 'Passport',
        'text699': 'National ID',
        'text700': 'Please select an ID Type',
        'text701': 'To Token Type',
        'text702': 'Receive',
        'text703': 'Please note that all fiat deposits will be automatically converted to USDC and will be reflected in your USDC wallet. Please note that deposits will be subjected to foreign currency exchange rates and fiat to USDC conversion fees.',
        'text704': 'Please note that a minimum initial deposit of 1,000 USDT/USDC or equivalent is required to activate your account.',
        'text705': 'Reset PIN',
        'text706': 'Enter New PIN',
        'text707': 'You are about to change the PIN associated with your card. Please ensure it is a 4-dight number that you will remember. Please be reminded to not share your PIN with anyone',
        'text708': 'Confirm New PIN',
        'text709': '',
        'text710': 'Category',
        'text711': 'Transaction Total',
        'text712': 'Transaction ID',
        'text713': 'I declare that the source of funds and use for this transaction is :',
        'text714': 'Sale of property',
        'text715': 'Business proceeds',
        'text716': 'Profits from business operations',
        'text717': 'Trading',
        'text718': 'Other',
        'text719': 'Service Fee',
        'text720': 'KYC-Approved',
        'text721': 'Dear Valued Customer,',
        'text722': 'Thank you for your interest in depositing ',
        'text723': ' to BETH.',
        'text724': 'At BETH, we currently accept deposits in USD, CNY, GPB, AUD, SGD and HKD which are converted and held in USDT and USDC.',
        'text725': 'Hence, as an added convenience to our BETH customers, we have partnered with PayBridge, to provide a seamless process of converting your ',
        'text726': ' to USDT (TRC20).  At PayBridge, you will be able to convert from over 47 different fiat currencies to USDT (TRC20) in a few simple steps after your KYC is approved.',
        'text727': 'Upon the successful conversion of your ',
        'text728': ' to USDT on Paybridge, your USDT will automatically be credited to your BETH USDT wallet within an hour.   To view your deposit balances, please visit your Account Dashboard.',
        'text729': 'Here is the summary of the process :',
        'text730': 'BETH --> Paybridge --> Complete simple PayBridge KYC--> Deposit fiat --> USDT automatically credited to your BETH USDT wallet',
        'text731': 'You will now be redirected to PayBridge.',
        'text732': '* Please note that every digital asset transfer is subjected to a ',
        'text733': ' of admin fee and a gas fee amount of ',
        'text734': ' ',
        'text735': 'Remark',
        'text736': '* Your wallet can only receive our designated type of tokens. If you have accidentally credited the wrong token, please contact support@finexteasternbank.com for assistance.',
        'text737': 'Transfer Fixed Fee in ',
        'text738': 'Transfer Charges ',
        'text738_2': ' in ',
        'text739': 'Transfer Fee',
        'text740': 'Transfer Fixed Fee',
        'text741': 'Deduct From',
        'text742': 'Top-up amount in ',
        'text743': 'Top-up fee in ',
        'text744': 'Total deduction in ',
        'text745': 'Balance after deduction ',
        'text746': 'My Account',
        'text747': 'Fiat Deposit',
        'text748': 'Digital Asset Deposit',
        'text749': 'Fiat Transfer & Payments',
        'text750': 'Digital Asset Transfer & Payments',
        'text751': 'Transaction Details',
        'text767': 'CARD LAST 4 DIGIT',
        'text768': 'TxnReference',
        'text769': 'Withdrawals',
        'text770': 'Deposits',
        'text771': 'Balance (Overdraft)',
        'text772': 'Transfer/Payment to Payee',
        'text773': 'Sender Account Name',
        'text774': 'Please fill in Sender Account Name',
        'text775': 'Green - Fiat Transaction',
        'text776': 'White - Digital Asset Transaction',
        'text777': 'COMMS',
        'text778': 'REFER',
        'text779': 'Bank Statements',
        'text780': 'Bank Statements ( Last 6 months )',
        'text781': 'Statements',
        'text782': 'All documents provided must be in the English language or accompanied by a certified translation thereof.',
        'text783': 'Transaction Advice',
        'text784': '',
        'text785': '',
        'text786': '',
        'text787': '',
        'text788': '',
        'text789': '',
        'text790': '',
        'text791': 'Others',
        'text792': 'Please note that a minimum initial deposit of 1,000 USD or equivalent is required to activate your account.',
        'text793': 'Received',



    },

    // 银行卡预约
    bank_card:{
        card_reservation        :"Pre-order Module",
        contract_management     :"Cards Pre-order Management",
        Card_management         :"Card Management",
        KYC_info                :"KYC Details",
        Personal_Details        :"Personal Details",
        Mobile_Phone            :"Mobile Phone",
        Gender                  :"Gender",
        Male                    :"Male",
        Female                  :"Female",
        Username_Beth           :"Username (for login at Beth)",
        Name_appear             :"Name to appear on card",
        Proof_Identity          :"Proof of Identity",
        Passport_National       :"Passport/National ID Number",
        Select_language         :"Select Document language",
        Address_Proof           :"Upload Proof of Address (Front Page)",
        Address_Proof_Back      :"Upload Proof of Address (Back, optional)",
        Address_Type            :"Proof of Address Type",
        Address_Language        :"Select Document language",
        Address_Issued_By       :"Address Issued By",
        Address_Issued_Date     :"Address Issued Date",
        reservation_management  :"Pre-order - Card Management",
        Please_enter_name       :"Enter name on card",
        Please_enter_email      :"Enter email",
        state                   :"Status",
        uncommitted             :"Uncommitted",
        approved                :"Approved",
        rejected                :"Rejected",
        active                  :"Activated",
        blocked                 :"Block",
        kyc_approved            :"KYC Approved",
        card_level              :"Card Tier",
        Premier                 :"Premier",
        Prestige                :"Prestige",
        Card_class              :"Card Type",
        VISA                    :"Visa",
        Mastercard              :"Mastercard",
        UnionPay                :"UnionPay",
        card_number             :"Card Number",
        There                   :"Total ",
        are_records             :" records",
        application_date        :"Request Date",
        Card_name               :"Name on card",
        email                   :"Email",
        Corporate_Clent         :"Corporate Clent",
        Card_Fee                :"Card Fee",
        unpaid                  :"Unpaid",
        paid                    :"Paid",
        Annual_Membership       :"Annual Membership",
        branded_card_level      :"Card Tier",
        branded_card_category   :"Card Type",
        Date_lssuse             :"Date of issue",
        Date_Expiry             :"Date of expiry",
        Corporate_Client_Action :"Corporate client action",
        Bind                    :"Bind",
        unbind                  :"Unbind",
        binding_card            :"Bind Card",
        create_time             :"Order date",
        order_id                :"Order ID",
        amount_num              :"Order amount",
        status_1                :"Pending",
        status_2                :"Approve",
        status_3                :"Declined",
        status_4                :"Partial allocated",
        status_5                :"Allocated",
        status_remark           :"Status Remark",
        operate                 :"Action",
        select                  :"Choose",
        allocated_cards         :"Allocated cards",
        kit_number              :"Kit Code",
        is_unbind               :"Are you sure to proceed to unbind the card?",
        confirm                 :"Confirm",
        bind_success            :"Bind successful",
        unbind_success          :"Cancel successful",
        card_issuing_record     :"Card Pre-order - Contract Management - View contract details - View card records",
        Date_issue              :"Issue date",
        check_order             :"Pre-order Module - Contract Management - View Order ",
        con_management          :"Cards Pre-Order Management - Contracts",
        Start_date              :"Start Date / End Date",
        Contract_ID             :"Contract ID",
        total_amount            :"Contracted Quantity",
        payment_amount          :"Paid Quantity",
        left_amount             :"Available quantity for order",
        order_amount            :"Ordered quantity",
        place_order             :"Order",
        View_the_contract       :"View Contract",
        check_an_order          :"View Order Details",
        order_num               :"Ordered quantity",
        Minimum_quantity        :"Minimum amount to order per batch",
        Contract_term_month     :"Contract Period",
        contract_quantity       :"Contracted Quantity",
        Number_reservation      :"Pre-order amount",
        zhang                   :"Cards",
        date_of_payment         :"Date of payment",
        di                      :"Number",
        Period_quantity         :"Quantity at deposit",
        Minimum_order_quantity  :"Minimum quantity to order per batch",
        available_quantity      :"Available quantity for issuance",
        Current_number_audited  :"Current pending KYC",
        Current_number_issued   :"Current pending issuance",
        Order_success           :"Order Successful",
        Allocated_quantity      :"Allocated quantity",
        unallocated_quantity    :"unallocated quantity",
        Ass_management          :"User Access Management",
        KYC_Processing          :"KYC Processing",
        Printing                :"Printing",
        Card_Binded             :"Cards Used",
        Activated               :"Activated",
        freeze                  :"Block",
        Whether_freeze_account  :"Proceed to block card?",
        Freezing_success        :"Block card successful",
        Total_Order             :"Total Order Quantity",
        Card_Unbind             :"Cards Available",
        KYC_Pending             :"Users Pending KYC",
        KYC_Approved_binded     :"Users Pending Card",
        username_email          :"Enter user access username/email",
        Subaccount_status       :"Account Status",
        start                   :"Active",
        forbidden               :"Inactivated",
        in_all                  :"Total",
        Bar_data                :"number of records",
        User_name_subaccount    :"Secondary account username",
        Subaccount_mailbox      :"Secondary account email",
        operation               :"Action",
        permission_view         :"View access rights",
        Ass_Acc_View            :"User Access Module - View Access rights",
        Remarks                 :"Remarks",
        group_name              :"User access group",
        describe                :"Description",
        thaw                    :"Unblock",
        Operation_Status        :"Operation Status",
        Successful_thawing      :"Unblock successfully",
        Card_Binded2            :"Card Binded",
        FEB_Debit_Cards         :"FEB Debit Cards",
        FEB_VISA_Premier        :"FEB VISA Premier",
        FEB_VISA_Premier_m      :"FEB VISA Premier (Metal)",
        View_Plan               :"View Plan",
        Directors_Staffs        :"Directors, Staffs and Associates are eligible to apply for this card.",
        Client_Block            :"Client Block",
        Admin_Block             :"Admin Block",
        User_Block              :"User Block",
        Enter_Code              :"Enter Code",
        Please_enter_OTP        :"Please enter the OTP verification code and click Verify to complete the verification",
        Verify                  :"Verify",
        Create_Password         :"Create Password",
        enter_Password          :"Re-enter Password",
        My_mailing_address      :"My mailing address is same as the residential address entered above.",
        Please_provide          :"Please provide the mailing address where you would like us to securely deliver your card.",
        For_ID_Card             :"For ID Card without issued date, insert date as of 18 years old.",
        ID_Card_without         :"For ID Card without expiry, add at least 55 years from the date of birth.",
        Important_Please        :"Important: Please upload English Translation of your Proof of Identity.",
        If_you_are              :"If you are submitting non-English documents, provide an English translation. Clearly label all essential information on the original document and upload the translated version. Use a reliable translation service if needed.",
        Image_File_Type         :"*Image File Type: jpeg, png, pdf file extension.",
        Image_Size_Limit        :"*Image Size Limit: up to 5MB per document.",
        Allow_up_to             :"*Allow up to 1 file uploads.",
        Please_upload_English   :"Important: Please upload English Translation of your Proof of Address.",
        label_in_English        :"(label in English)",
        Please_ensure_that      :"Please ensure that the Proof of Address shows your name, address and date.",
        Issuing_authority       :"Issuing authority name, such as the name of the utility company or bank.",
        Must_be_dated           :"Important: Proof of Address must be dated within three months (90 days) from the submission date.",
        Notes                   :"Notes:",
        Ensure_documents        :"Ensure that the documents you submit match the information provided in your application form.",
        Submit_complete         :"Submit a complete identity document without blocking or cropping any details.",
        Take_clear              :"Take clear and focused images, avoiding any blurring of important information.",
        When_capturing          :"When capturing the document image, ensure that the camera is parallel to the document to avoid skewed distortions.",
        Do_not_add              :"Do not add watermarks or any text indicating the purpose of use.",
        If_your_full            :"If your full name has a middle name or second last name, you only need to provide your first name and last name for KYC submission.",
        Please_email_verif      :"Please complete email verification",
        enter_PIN               :"Please enter the password",
        enter_pwd_verif         :"Please enter password verification",
        pwd_not_match           :"The two passwords do not match",
        Please_Gender           :"Please select Gender",
        mailing_address         :"Please fill in the mailing address",
        mail_country            :"Please select the mailing country",
        mail_city               :"Please fill in the mailing city",
        mail_state              :"Please fill in the mailing area",
        mail_postal_code        :"Please fill in the mailing code",
        upload_file_first       :"Please upload the file",
        Verify_name_first       :"Please verify the username",
        verify_email_first      :"Please verify the email address",
        Email_verification      :"Email verification passed",
        name_succeeded          :"Username verification passed",
        Cancelled               :"Cancelled",
        Driver_License          :"Driver License",
        Insurance_Policy        :"Insurance Policy",
        Post_Balance            :"Post Office Balance Certificate",
        Other_Government        :"Other Government Issued Document",
        card_cost_status        :"Card Fee Status",
        card_cost_status0       :"Unpaid",
        card_cost_status1       :"Paid",
        card_cost               :"Card Fee",
        Corporate_Clent_Prefix  :"Company Name",
        The_company             :"Corporate Clent Prefix is required, please set the company name",
        Click_jump              :"Click to next",
        KYC_Management          :"KYC Status",
        mailed                  :"Email",
        Card_anomaly            :"Card Exception ",
        Refuse_card             :"Card not replaced",
        replacement_card        :"Pending Replacement",
        Rep_card                :"To replace",
        Reissued_card           :"Replaced",
        Consolidating           :"Consolidating",
        Print_batch_number      :"Print Lot No.",
        company_abbreviation    :"Company Name",
        delivery_type           :"Delivery Type",
        print_number            :"Print Lot No.",
        op_status_time          :"OPS Status Date",
        op_cause_type1          :"Stolen/Lost",
        op_cause_type2          :"Damaged",
        op_cause_type3          :"User Damaged",
        op_cause_type4          :"Factory Damaged",
        op_cause_type5          :"Activte Fail",
        op_cause_type6          :"Set pin fail",
        op_cause_type7          :"Delivery Issue",
        op_cause_type8          :"Fraud",
        op_cause_type9          :"Delivery Not Returned",
        op_cause_type10         :"Delivery Returned",
        active_fail_reason      :"Activation fail reason",
        mail_address            :"Mailing Address",
        View                    :"View",
        Modify_status           :"Modify operation status",
        Please_op_status        :"Select a status",
        Card_abnormal_cause     :"Card abnormal cause",
        Select_card_cause       :"Select exception case",
        Username                :"Username",
        Role                    :"Role",
        Apply_For               :"Apply For",
        Staff                   :"Staff",
        kyc_id_status           :"Kyc Id Status",
        Under_Review            :"Under Review",
        kyc_address_status      :"Kyc Address Status",
        KYC_Message             :"KYC Message",
        reject_reason1          :"Data error",
        reject_reason2          :"Status error",
        reject_reason3          :"KYC not approved",
        reject_reason4          :"Allocation Fail",
        reject_reason5          :"Activition Fail",
        reject_reason6          :"Set Pin Fail",
        Operator                :"Operator",
        No_more_than_5          :"Not more than 5 characters",
        mailed_s                :"Mailed",
        For_banking_login       :"For internet banking login",
        not_filed               :"Uncommitted",
        annual_fee_status       :"Annual Fee Status",
        card_replace_fee        :"Card Replace Fee",
        card_price              :"base cost per card",
        sale_name               :"Relationship manager",
        design_details          :"Card Material&Design",
        design_category         :"Design Category",
        material                :"Material",
        material_color          :"Material Colour",
        font_color              :"Font Colour",
        feb_logo                :"FEB LOGO",
        merchant_logo           :"Client LOGO",
        card_picture            :"Card Image",
        Packing_arrangement     :"Packaging Type",
        packaging_type          :"Packaging Type",
        done_by                 :"Done By",
        cost_to_client          :"Cost to Client",
        stage                   :"Delivery",
        from_to                 :"From To",
        printing_type           :"Printing Type",
        delivery_note           :"Delivery Notes",
        delivery_address        :"Delivery Address",
        contract                :"Contact",
        mobile_no               :"Mobile No",
        contract_id             :"Contract ID",
        prepayment              :"Prepayment",
        returned                :"Returned",
        There_problem_image     :"There is a problem with the image format you uploaded. Please try again with another image format.",
        Collaborative_Cards     :"Collaborative Cards",
        Pending_Rebind          :"Pending Rebind",
        Upload_error            :"The file upload fails. Please change the network refresh page and try again",
        card_username           :"Card Username",
        top_up_fee              :"Top-Up Fee",
        min_top_up              :"Minimum Top-Up",
        max_top_up              :"Maximum Top-Up",
        Full_Contract_Summary   :"Full Contract Summary Table",
        Contracted_Paid         :"Contracted Quantity - Paid",
        Card_Qty_Order          :"Card Qty available for Order",
        Total_Cards_Ordered     :"Total Cards Ordered",
        Total_Cards_Allocated   :"Total Cards Allocated",
        Order_Summary_Page      :"Order Summary Page",
        Card_Qty_Allocation     :"Card Qty Pending Allocation",
        Card_Qty_Bind           :"Card Qty available for Bind",
        Cards_ordered_available :"Cards ordered and available",
        Total_Cards_Used        :"Total Cards Used",
        Card_Qty_print          :"Card Qty Reserved for print",
        Card_Qty_pending_Bind   :"Card Qty printed pending Bind",
        Card_Qty_Activation     :"Card Qty awaiting Activation",
        Total_Cards_Activated   :"Total Cards Activated",
        Total_Cards_Bind        :"Total Cards Bind",
        Users                   :"Users",
        users_kyc_approved      :"Total Users KYC Approved",
        users_pending_kyc       :"Current Users Pending KYC",
        pending_consolidation   :"Current Users Pending Consolidation",
        pending_payment         :"Current Users Pending Payment",
        pending_users           :"Pending Users",
        users_reserved_print    :"Current Users Reserved for print",
        printed_pending_bind    :"Current Users printed pending Bind",
        awaiting_activation     :"Current Users awaiting Activation",
        with_card_activated     :"Total Users with card Activated",
        with_card_bind          :"Total users with Card Bind",
        card_array              :"Card Array",
        plus_price              :"Base cost per card",
        data_problem            :"Data error",
        state_problem           :"Status error",
        User_kyc_failed         :"User is not KYC approved",
        Allocation_card_failure :"Failed to allocate cards",
        Activation_failure      :"Failed to activate card",
        Failed_set_pin          :"Failed to set PIN",
        Webhook_notif           :"Webhook Notification Settings",
        After_the_setting       :"Once set up successfully, you will receive relevant notifications for status changes.",
        Please_API_link         :"Please fill in the API link.",
        KYC_status_change       :"KYC Status Change Notification",
        status_noti             :"Topup Status Notification",
        Card_status_noti        :"Card Operation Status Notification",
        activation_success      :"Card Activation Notification",
        Cancelling              :"Cancelling",
        Beth_API_Status         :"Beth/API Status",
        CONTROLS                :"CONTROLS",
        Cards_List              :"Cards List",
        Card_mailing_address    :"Card mailing address",
        Mail_Address_Line       :"Mailing Address Line 1",
        Mail_Address_Line2      :"Mailing Address Line 2",
        Mail_City               :"Mailing City",
        Mail_State              :"Mailing State",
        Mail_Country            :"Mailing Country",
        Mail_Postal_Code        :"Mailing Postal Code",
        Security_Code           :"Activation Code",
        Sales_Type              :"Sales Type",
        General                 :"General",
        QR_Code                 :"QR Code",
        verify_passed           :"Verification Passed",
        v_kit_number_code       :"Please complete the verification of Kit Code and Activation Code first. If you have any questions, please contact customer service.",
        URL                     :"URL",
        operating_time          :"Operating Time",
        r_w_get                 :"Recipient will get",
        Conversion_fee          :"Conversion fee of ",
        Flat_Fee                :"Flat Fee",
        Amount_Deducted         :"Amount Deducted",


    },

    beth_text:{
        Residential_address         :"Residential Address",
        Mail_Address_Line           :"Address Line 1",
        Mail_Address_Line2          :"Address Line 2",
        Mail_City                   :"City",
        Mail_State                  :"State",
        Mail_Country                :"Country",
        Mail_Postal_Code            :"Postal Code",
        Block_Card                  :"Block Card",
        Replace_Card                :"Lost/Damaged",
        renew                       :"Renew",
        Expired                     :"Expired",
        Confirmed_freezing          :"Proceed to temporarily block usage of this card? You won't be able to use this card until you unblock it.",
        Confirmed_thawing           :"Proceed to unblock this card? After unblocking, you may use the card again.",
        Reason_replacement          :"Reason for Replacement",
        Card_loss                   :"Card is Lost",
        Confirm_to_freeze           :"Proceed to block your card and process a card replacement fee of {fee} USDC/T This action is irreversible.",
        address_accurate            :"Please ensure your mailing address is updated to ensure the receipt of the new card.",
        Card_damage                 :"Card is Damaged",
        Not_sure_card               :"Misplaced your card?",
        Temporarily_block_it        :"Temporarily block it",
        Temporarily_block_it_btm    :" to stop new transactions.",
        card_recovered              :"If you find your card, you may unblock it and resume usage.",
        Whether_damaged             :"Uncertain if card is damaged? You may contact customer service before taking further action.",
        Mailing_address_accurate    :"Please make sure your mailing address is accurate to receive your new card.",
        card_administrator          :"Unable to proceed, your card has been blocked by system admin.",
        password_cannot_changed     :"Current status does not support password reset.",
        Freezing_success            :"Blocked successfully",
        applied_replacement_card    :"Unable to unblock card due to card replacement requested. Contact customer service should you require further assistance.",
        card_frozen_administrator   :"Your card has been blocked by system admin. Contact customer service should you require further assistance.",
        Card_replacement_success    :"Card replacement request successful",
        msg_notice                  :"Notifications",
        system_notice               :"Announcements",
        Clear_unread                :"Mark All as Read",
        Clear_successfully          :"Cleared successfully",
        Automatic_annual_renewal    :"Auto Fee Renewal",
        Ticked_FEB                  :"Your next membership fee of {payment_amount} USDC/T (for {payment_month} months) will be automatically deducted from your parent corporate account on {payment_date}.",
        Ticked_Beth                 :"Your next membership fee of {payment_amount} USDC/T (for {payment_month} months) will be automatically deducted on {payment_date} from your Beth wallet balance. Please ensure sufficient balance to avoid service disruptions.",
        Please_make                 :"Please make payment of {payment_amount} USDC/T (for {payment_month} months) by {payment_date} to avoid cancellation of your card.",
        Current_Annual              :"Current Annual Membership Fee :{current_amount} USDC/T",
        Card_No                     :"Card No.",
        Expiry_Date                 :"Expiry Date (good thru)",
        Term_Start_Date             :"Term Start Date",
        Term_End_Date               :"Term End Date",
        Auto_Renewal_Date           :"Due Date",
        Payment_Months              :"Term (Months)",
        Membership_Fee_Due          :"Membership Fee Due",
        Payment_Status              :"Payment Status",
        pay                         :"Pay",
        pay1                        :"Paid",
        pay_another                 :"Pending",
        overdue                     :"Overdue",
        unpaid                      :"Unpaid",
        Payment_Date                :"Payment Date",
        need_to_pay                 :"You need to make a payment of {payment_amount} USDC/T for this transaction. Would you like to proceed?",
        successfully_set            :"Updated successfully",
        payment_success             :"Payment successful",
        renewal_first               :"Please process the previous renewal first",
        Free_annual_fee             :"Waived",
        feb_account                 :"Your FEB account needs to pay {payment_amount} USD C/T for this transaction. Are you sure to continue?",
        Account_Balance             :"Account Balance",
        Delete_Read                 :"Delete Read",
        Card_Name                   :"Card Name",
        Cardholder_Agreement        :"Cardholder Agreement",
        read_agree                  :"Accept",
        Unticked_Please             :"Please make payment of {payment_amount} USDC/T (for {payment_month} months) by {payment_date} to avoid cancellation of your card.",
        Your_been                   :"Your card has been indicated for non-renewal and will expire on {annual_fee_end_time}, please contact customer service should you require further assistance.",


    },
    
    pdf: {
        'text1': 'Debit Card',
        'text2': 'Statement of Account',
        'text3': 'CARD SUMMARY',
        'text4': 'Statement Date',
        'text5': 'Load Capacity',
        'text6': 'Opening Balance',
        'text7': 'Credit and Top-ups',
        'text8': 'Purchases & Withdrawals',
        'text9': 'Fees & Charges',
        'text10': 'Closing Balance',
        'text11': 'Next Renewal Period:',
        'text12': 'Page',
        'text13': 'For account or card enquiries, please log on to www.bethfinance.com',
        'text14': 'FEB VISA DEBIT',
        'text15': 'Txn Date',
        'text16': 'Description',
        'text17': 'Amount',
        'text18': 'Balance',
        'text19': 'GRAND TOTAL',
        'text20': 'The ending balance does not reflect any pending withdrawals or holds on deposited funds that may have been outstanding on your account when your transactions posted. If you had insufficient available funds when a transaction posted, fees may have been assessed.',
        'text21': 'IMPORTANT NOTICES',
        'text22': 'Protect Yourself from Fraud & Scam',
        'text23': 'Never share your personal login credentials (i.e. User ID & Password) and Debit card PIN to anyone.',
        'text24': 'Reset Your PIN Now',
        'text25': 'Forget your Debit card PIN? You can reset your PIN instantly by logging in to your account via the Beth dashboard.',
        'text26': 'Debit Card Information Sheet',
        'text27': 'This information is intended as a quick consumer guide only. For full details read the respective Cardholder Agreement which prevails at all times.',
        'text28': 'Load Capacity',
        'text29': 'You may add funds to your Card Account at any time, but you may not exceed the Load Capacity. ',
        'text30': 'Transactions Made in Foreign Currencies',
        'text31': 'If you make a transaction in a foreign currency, the Payment Card Network such as VISA will convert it into a U.S. Dollar amount. The Payment Card Network will use its own currency conversion procedures. The conversion rate in effect on the processing date may differ from the rate in effect on the transaction date that appears on your Statement. We may adjust the currency exchange rate or charge additional currency conversion Fees.',
        'text32': 'Transaction Charges',
        'text33': 'Top-up Fees',
        'text34': 'POS/Online Purchase',
        'text35': 'ATM Cash Withdrawal Charges',
        'text36': 'ATM Balance Inquiry',
        'text37': 'Transaction Parameters',
        'text38': 'Load Capacity',
        'text39': 'as per card type',
        'text40': 'Minimum Stored Value',
        'text41': 'Maximum Top-up per Transaction',
        'text42': 'Maximum number of transactions per day',
        'text43': 'Maximum number of transactions per month',
        'text44': 'Maximum value per transaction',
        'text45': 'Maximum transaction value per day',
        'text46': 'Maximum transaction value per month',
        'text47': 'Maximum number of withdrawals per day',
        'text48': 'Maximum number of withdrawals per month',
        'text49': 'Maximum withdrawal value per day',
        'text50': 'Maximum withdrawal value per month',
        'text51': 'Service Charges',
        'text52': 'Card Fee',
        'text53': 'Card Activation Fee',
        'text54': 'Card Replacement Fee',
        'text55': 'Monthly Service Fee',
        'text56': 'Annual Membership Fees',
        'text57': 'In the event of any inconsistency between any of the printed information in this statement of account and the Cardholder Agreement, the latter will prevail.',
        'text58': '',
        'text59': '',

        text77: "SERVICES ADDL CARD FEE",
    },
    v_life:{
        visionLife_id   :"VisionLife ID",
        verify_v_id     :"Format error, combination of letters, numbers, and special characters, 5 to 20 digits；",
        id_verify_passed:"VisionLife ID Verification Passed",
        please_v_id     :"Please fill in the VisionLife account",
        read_content    :"Please scroll down and accept the Agreement to continue",
        Privacy_Data    :"Privacy and Data Usage Statement",
        We_your_privacy :"We value your privacy and are committed to safeguarding your personal information. The data you provide in this application will be exclusively used for account processing and identity verification. We will not disclose your data to third parties unless compelled by legal requirements.",
        Card_Name       :"Card Name",
    },
    str_status:{
        str_status_1:"Uncommitted",
        str_status_2:"Pending Review",
        str_status_3:"Success",
        str_status_4:"Fail",
    },
    top_up_dlg:{
        Max_per     :"Max per transaction:",
        Current_Cap :"Current Top-up Cap:",
        Source_fund :"Source of fund",
        E_Income    :"Employment Income",
        I_Income    :"Investment Income",
        B_Income    :"Business Income",
        Savings     :"Savings",
        Loans       :"Loans",
        Sales_I     :"Sales of Investment",
        Gifts       :"Gifts",
        Others      :"Others",
        I_confirm   :"I confirm that these funds are derived from legitimate sources as state above, and commit to providing necessary proof of source if required in the future.",
        Please_check:"Please check the above content first to submit the application",
        t_status1   :"Success",
        t_status2   :"Canceled",
        t_status3   :"Processing",
        t_status4   :"Retry",
        t_status5   :"Refunded",
        P_may       :"Processing may take 3-5 business days for this top-up amount.",
    },
    beth_text2:{
        Residential_address         :"Residential Address",
        Mail_Address_Line           :"Address Line 1",
        Mail_Address_Line2          :"Address Line 2",
        Mail_City                   :"City",
        Mail_State                  :"State",
        Mail_Country                :"Country",
        Mail_Postal_Code            :"Postal Code",
        Block_Card                  :"Block Card",
        Replace_Card                :"Lost/Damaged",
        renew                       :"Renew",
        Expired                     :"Expired",
        Confirmed_freezing          :"Proceed to temporarily block usage of this card? You won't be able to use this card until you unblock it.",
        Confirmed_thawing           :"Proceed to unblock this card? After unblocking, you may use the card again.",
        Reason_replacement          :"Reason for Replacement",
        Card_loss                   :"Card is Lost",
        Confirm_to_freeze           :"Proceed to block your card and process a card replacement fee of {fee} USDC/T This action is irreversible.",
        address_accurate            :"Please ensure your mailing address is updated to ensure the receipt of the new card.",
        Card_damage                 :"Card is Damaged",
        Not_sure_card               :"Misplaced your card?",
        Temporarily_block_it        :"Temporarily block it",
        Temporarily_block_it_btm    :" to stop new transactions.",
        card_recovered              :"If you find your card, you may unblock it and resume usage.",
        Whether_damaged             :"Uncertain if card is damaged? You may contact customer service before taking further action.",
        Mailing_address_accurate    :"Please make sure your mailing address is accurate to receive your new card.",
        card_administrator          :"Unable to proceed, your card has been blocked by system admin.",
        password_cannot_changed     :"Current status does not support password reset.",
        Freezing_success            :"Blocked successfully",
        applied_replacement_card    :"Unable to unblock card due to card replacement requested. Contact customer service should you require further assistance.",
        card_frozen_administrator   :"Your card has been blocked by system admin. Contact customer service should you require further assistance.",
        Card_replacement_success    :"Card replacement request successful",
        msg_notice                  :"Notifications",
        system_notice               :"Announcements",
        Clear_unread                :"Mark All as Read",
        Clear_successfully          :"Cleared successfully",
        Automatic_annual_renewal    :"Auto Fee Renewal",
        Ticked_FEB                  :"Your next membership fee of {payment_amount} USDC/T (for {payment_month} months) will be automatically deducted from your parent corporate account on {payment_date}.",
        Ticked_Beth                 :"Your next membership fee of {payment_amount} USDC/T (for {payment_month} months) will be automatically deducted on {payment_date} from your Beth wallet balance. Please ensure sufficient balance to avoid service disruptions.",
        Please_make                 :"Please make payment of {payment_amount} USDC/T (for {payment_month} months) by {payment_date} to avoid cancellation of your card.",
        Current_Annual              :"Current Annual Membership Fee :{current_amount} USDC/T",
        Card_No                     :"Card No.",
        Expiry_Date                 :"Expiry Date (good thru)",
        Term_Start_Date             :"Term Start Date",
        Term_End_Date               :"Term End Date",
        Auto_Renewal_Date           :"Due Date",
        Payment_Months              :"Term (Months)",
        Membership_Fee_Due          :"Membership Fee Due",
        Payment_Status              :"Payment Status",
        pay                         :"Pay",
        pay1                        :"Paid",
        pay_another                 :"Pending",
        overdue                     :"Overdue",
        unpaid                      :"Unpaid",
        Payment_Date                :"Payment Date",
        need_to_pay                 :"You need to make a payment of {payment_amount} USDC/T for this transaction. Would you like to proceed?",
        successfully_set            :"Updated successfully",
        payment_success             :"Payment successful",
        renewal_first               :"Please process the previous renewal first",
        Free_annual_fee             :"Waived",
        feb_account                 :"Your FEB account needs to pay {payment_amount} USD C/T for this transaction. Are you sure to continue?",
        Account_Balance             :"Account Balance",
        Delete_Read                 :"Delete Read",
        Card_Name                   :"Card Name",
        Cardholder_Agreement        :"Cardholder Agreement",
        read_agree                  :"Accept",
        Renewal_Status              :"Renewal Status",
        free_charge                 :"N.A.",
        due_soon                    :"Upcoming",
        Deduction_Mode              :"Deduction Mode",
        auto                        :"Auto",
        automatically               :"Confirmed Paying",
        stop                        :"Stop",
        Modify_Mode                 :"Modify Mode",
        Edit_Remarks                :"Edit Remarks",
        Pending_status              :"Pending",
        Discontinued                :"Discontinued",
        User                        :"User",
        yearly_expire_date          :"Yearly Expire Date",

    },
    new1_txt:{
        Unsettled           :"Unsettled",
        Settled             :"Settled",
        CR                  :"CR",
        DR                  :"DR",
    },
    new3_txt:{
        P_Resubmission      :"Pending User Resubmission",
        KYC_Rejected        :"KYC Rejected",
        ekyc_link           :"eKYC Link",
    }
}